<template>
  <div class="layout__view">
    <RouterView v-slot="{ Component }" class="page">
      <Transition name="page" mode="out-in" appear>
        <component v-if="$beet.isReady" :is="Component" :key="$route.path" />
      </Transition>
    </RouterView>
  </div>
  <GoogleSearchBar v-if="$beet.isReady && $mq.smPlus" />
  <NavBar />
  <SiteFooter />
  <RouterLink
    :to="{ ...$route, query: { ...$route.query, contact: true } }"
    :class="['bubble', '-contact', { '-hidden': $route.query.contact }]"
  >
    <Icon id="contact" class="mail" />
  </RouterLink>
  <ContactPanel />
  <SideNav />
  <ReturnToTop />
  <ImageModal />
  <NewsletterModal />
</template>

<script>
import ContactPanel from '@/components/ContactPanel.vue'
import Icon from '@/components/global/Icon.vue'
import GoogleSearchBar from '@/components/googleServices/GoogleSearchBar.vue'
import NavBar from '@/components/NavBar.vue'
import ImageModal from '@/components/partials/ImageModal.vue'
import NewsletterModal from '@/components/partials/NewsletterModal.vue'
import ReturnToTop from '@/components/partials/ReturnToTop.vue'
import SideNav from '@/components/SideNav.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'App',
  components: {
    Icon,
    ImageModal,
    NavBar,
    SiteFooter,
    ContactPanel,
    SideNav,
    GoogleSearchBar,
    NewsletterModal,
    ReturnToTop,
  },
  metaInfo: {
    title: 'Ville éponge',
    titleTemplate: '%s | Ville éponge',
  },
  beforeMount() {
    this.$beet.fetchCoreData()
  },
  mounted() {
    window.setTimeout(() => {
      if (this.$route.hash)
        document
          .getElementById(this.$route.hash.replace('#', ''))
          ?.scrollIntoView({ behavior: 'smooth' })
    }, 1000)
  },
}
</script>
